import React, { useState, useEffect, useContext } from 'react';
import {
    Box, FormControl, Button,
    FormGroup, FormControlLabel, Checkbox
} from '@mui/material';
import { withStyles } from '@mui/styles';
import './FilterBox.css';
import PropTypes from 'prop-types';
import { TeamAlertsContext } from '../../../../../../context/team-alerts-context';
import SearchInput from './SearchInput';
import { chunkArrayInGroups } from '../../../../../../utils/arrays';

const FilterBox = ({ handleApplyFilter, filterType }) => {
    const { gridFilterOptions } = useContext(TeamAlertsContext);
    const [pageIndex, setPageIndex] = useState(0);
    const [paginatedFilterOptions, setPaginatedFilterOptions] = useState([]);
    const [searchParameter, setSearchParameter] = useState('');
    const [searchResultset, setSearchResultset] = useState([]);

    const StyledFormControlLabel = withStyles(() => ({
        label: {
            fontWeight: 'bold'
        }
    }))(FormControlLabel);

    const StyledButton = withStyles(() => ({
        root: {
            color: '#fff !important',
            borderRadius: '0px !important',
            left: '150px',
            width: '120px',
            backgroundColor: 'var(--primary)',
            marginTop: '30px',
            marginBottom: '20px'
        }
    }))(Button);

    const handleSearch = (value) => {
        setSearchParameter(value);
    }

    const handleOptionChange = (optionTitle) => {
        const optionsUpdated = paginatedFilterOptions.map((page) => {
            const copyPage = page.map(item => ({ ...item }));
            const pageWithOptionsUpdated = copyPage.map(option => {
                const copyOption = { ...option }
                if (copyOption.title === optionTitle) {
                    copyOption.isActive = !(copyOption.isActive);
                }

                return copyOption;
            });

            return pageWithOptionsUpdated;
        });

        setPaginatedFilterOptions(optionsUpdated);
    }

    const handleOnClickApply = () => {
        const extractedOptions = [];
        paginatedFilterOptions.map((page) => page.map((option) => extractedOptions.push(option)));
        const options = { ...gridFilterOptions, [filterType]: { ...gridFilterOptions[filterType], options: extractedOptions } }
        handleApplyFilter(paginatedFilterOptions, options);
    }

    const handleClickOnMore = () => {
        if (pageIndex < paginatedFilterOptions.length) {
            setPageIndex(pageIndex + 1);
            const selection = document.querySelector('.filter-options-box');
            selection.scrollTo(0,0);
        }
    }

    const handleClickOnPrevious = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1);
        }
    }

    const optionsWithCheckbox = () => {
        let content = null;

        if (searchResultset) {
            if (searchResultset[pageIndex]) {
                content = searchResultset[pageIndex].map((option) =>
                    <StyledFormControlLabel
                        key={option.title}
                        control={<Checkbox checked={option.isActive} onChange={() => handleOptionChange(option.title)} name={option.title} />}
                        label={option.title}
                    />
                );
            }
        }

        return content;
    }

    useEffect(() => {
        if (searchParameter.trim() !== '' && paginatedFilterOptions.length) {
            const optionsFromResultset = [];

            paginatedFilterOptions.map((page) => {
                page.map((ac) => {
                    if (ac.title.toUpperCase().startsWith(searchParameter.toUpperCase())) {
                        optionsFromResultset.push(ac);
                    }

                    return null;
                });

                return null;
            });

            const options = paginatedFilterOptions.map(item => ({ ...item }));
            options[pageIndex] = optionsFromResultset;

            setSearchResultset(options);
        }
        else {
            setSearchResultset(paginatedFilterOptions);
        }
    }, [searchParameter, paginatedFilterOptions]);

    useEffect(() => {
        if (gridFilterOptions[filterType].options) {
            if (gridFilterOptions[filterType].options.length) {
                const filterOptionsPaginated = chunkArrayInGroups(gridFilterOptions[filterType].options, 100);
                setPaginatedFilterOptions(filterOptionsPaginated);
            }
        }
    }, [gridFilterOptions]);

    return (
        <Box className='filter-box'>
            <SearchInput
                key='textfield'
                value={searchParameter}
                handleChange={handleSearch}
                placeholder='Search'
            />
            <Box className='filter-options-box'>
                {pageIndex > 0 && paginatedFilterOptions.length > 0 && !searchParameter && <Button className='button-filter-options-list' onClick={handleClickOnPrevious}>See Previous</Button>}
                <FormControl key='formcontrol' component='fieldset'>
                    <FormGroup key='formGroup'>
                        {optionsWithCheckbox()}
                    </FormGroup>
                </FormControl>
                {pageIndex + 1 < paginatedFilterOptions.length && !searchParameter && <Button className='button-filter-options-list' onClick={handleClickOnMore}>Load More</Button>}
            </Box>
            <StyledButton className='button-apply' onClick={handleOnClickApply}>Apply</StyledButton>
        </Box>);
}

FilterBox.propTypes = {
    handleApplyFilter: PropTypes.func.isRequired,
    filterType: PropTypes.string.isRequired
}

export default FilterBox;
